import { useDispatch } from 'react-redux';
import { Button, Typography, Modal, Icon } from '@safedns/skydns-ui-react-lib';

import { useGetUserQuery, useDeleteDomainMutation } from '../../services/ADapi';

import { notificationSuccess } from '../../store/notificationReducer';

import styles from '../../styles/deleteModal.module.scss';

import sprite from '../../icons/sprite.svg';

const RemoveDomain = ({ domainId, domainName, isClosed, onClose }) => {
  const dispatch = useDispatch();

  const {
    data: { user_id },
  } = useGetUserQuery();

  const notification = {
    isNotification: true,
    type: 'success',
    action: 'remove_domain',
    message: `${domainName} удален`,
  };

  const [deleteDomain] = useDeleteDomainMutation();

  const deleteDomainHandler = async () => {
    try {
      await deleteDomain({
        user_id,
        id: domainId,
      }).unwrap();
      onClose();
      dispatch(notificationSuccess(notification));
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      isOpen={isClosed}
      title="Удалить агент?"
      onClose={onClose}
      sx={{ maxWidth: 460 }}
    >
      <div className={styles['modal-content']}>
        <div className={styles['icon-wrapper']} style={{ marginBottom: 16 }}>
          <Icon
            id="remove"
            sprite={sprite}
            width={24}
            height={24}
            color="white"
          />
        </div>
        <Typography
          sx={{
            paddingBottom: 8,
            textAlign: 'center',
            fontWeight: 500,
          }}
        >
          Вы уверены, что хотите удалить
          <br />
          &nbsp;"{domainName}"?
        </Typography>
        <Typography
          variant="body1"
          className={styles['modal-description']}
          sx={{ paddingBottom: 24, textAlign: 'center' }}
        >
          Пользователи и коллекции, связанные с этим доменом, также будут
          удалены.
        </Typography>
        <div className="button-grid">
          <Button variant="secondary" onClick={onClose} size="small">
            Отмена
          </Button>
          <Button variant="primary" size="small" onClick={deleteDomainHandler}>
            Удалить
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveDomain;
